import PropTypes from 'prop-types';
import RangeIndicator from './RangeIndicator';

export default function VitaminRow({ test }) {
  const convertedRanges = {
    min: test.ranges?.min || 0,
    low: test.ranges?.low || 0,
    normal: test.ranges?.high || 0,
    high: test.ranges?.max || 0,
    max: test.ranges?.max || 0,
    optimalMax: test.ranges?.optimalMax || 0,
  };

  const deriveStatus = (t) => {
    const valueNum = Number(t.value);
    if (t.sections && Array.isArray(t.sections)) {
      for (const section of t.sections) {
        if (valueNum >= section.min && valueNum <= section.max) {
          if (section.color === 'grey') {
            return 'attention';
          } else if (section.color === 'green') {
            return 'optimal';
          } else if (section.color === 'blue') {
            return 'acceptable';
          }
        }
      }

      for (let i = 0; i < t.sections.length - 1; i++) {
        const left = t.sections[i].max;
        const right = t.sections[i + 1].min;
        if (valueNum > left && valueNum < right) {
          const nextSection = t.sections[i + 1];
          if (nextSection.color === 'green') {
            return 'optimal';
          } else if (nextSection.color === 'blue') {
            return 'acceptable';
          } else if (nextSection.color === 'grey') {
            return 'attention';
          }
        }
      }
    }

    const r = t.ranges || {};
    const okMin = Number(r.low);
    const okMax = Number(r.max);
    const optimalMinRaw = r.high;
    const optimalMin = Number(optimalMinRaw);
    const optimalMaxRaw = r.optimalMax;
    const optimalMax = Number(optimalMaxRaw);

    if (
      !Number.isNaN(optimalMin) &&
      !Number.isNaN(optimalMax) &&
      valueNum >= optimalMin &&
      valueNum <= optimalMax
    ) {
      return 'optimal';
    }

    if (!Number.isNaN(okMin) && valueNum < okMin) return 'attention';
    if (!Number.isNaN(okMax) && valueNum > okMax) return 'attention';

    return 'acceptable';
  };

  const computedStatus = deriveStatus(test);

  const chartMaxByName = {
  };

  const chartMaxLabel = chartMaxByName[test.name];

  return (
    <div className="border-b border-gray-100 -mx-4 md:-mx-8 px-4 md:px-8 py-4">
      <div className="flex flex-col md:grid md:grid-cols-[220px_140px_minmax(0,1fr)] md:items-center md:gap-6">
        <div className="flex items-center justify-between gap-3 w-full md:w-auto md:justify-start">
          <p className="text-[#2B3133] font-poppins text-sm md:text-base font-semibold">
            {test.name}
          </p>
          <div className="flex items-center gap-2 md:hidden">
            <p
              className="font-poppins text-sm font-semibold"
              style={{
                color:
                  computedStatus === 'attention'
                    ? '#FF5959'
                    : computedStatus === 'acceptable' || computedStatus === 'ok'
                      ? '#42B1D0'
                      : '#119975',
              }}
            >
              {test.value}
            </p>
            <p className="text-[#889696] font-poppins text-xs">{test.unit}</p>
          </div>
        </div>
        <div className="hidden md:flex items-center gap-2">
          <p
            className="font-poppins font-semibold"
            style={{
              color:
                computedStatus === 'attention'
                  ? '#FF5959'
                  : computedStatus === 'acceptable' || computedStatus === 'ok'
                    ? '#42B1D0'
                    : '#119975',
            }}
          >
            {test.value}
          </p>
          <p className="text-[#889696] font-poppins text-sm">{test.unit}</p>
        </div>
        <div className="w-full md:ml-0 mt-3 md:mt-0">
          <RangeIndicator
            value={test.value}
            ranges={convertedRanges}
            sections={test.sections}
            status={computedStatus}
            chartMaxLabel={chartMaxLabel}
          />
        </div>
      </div>
    </div>
  );
}

VitaminRow.propTypes = {
  test: PropTypes.object.isRequired,
};
